export const plantStatusLabels: Record<string, string> = {
  OPEN: "Neue Bestellung",
  READ: "Gesehen",
  CHANGED: "Geändert",
  MOVED: "Verschoben",
  PACKED: "Gepackt",
  STORNO: "Storniert",
  DELETED: "Gelöscht",
  RETRACTED: "Zurückgezogen",
};

export function plantTime(value: string | null | undefined): string {
  if (!value) return "–";
  if (value === "none") return "anschließend";
  if (value.startsWith("xB")) {
    const [time, loading = "0", route = "0", direction = "0"] = value
      .slice(2)
      .split("+");
    const parts = /^(\d{1,2}):(\d{2})$/.exec(time);
    if (!parts) return "–";
    const minutes =
      (Number(parts[1]) * 60 +
        Number(parts[2]) +
        (direction === "1" ? -1 : 1) * (Number(loading) + Number(route)) +
        1440) %
      1440;
    return `${Math.floor(minutes / 60)
      .toString()
      .padStart(2, "0")}:${(minutes % 60).toString().padStart(2, "0")}`;
  }

  return (
    (
      {
        xAM: "vormittags",
        xPM: "nachmittags",
        xAFTER: "anschließend",
      } as Record<string, string>
    )[value] ?? value
  );
}

/** BOB's compact truck description; extended editing continues to use its rich controls. */
export function transportDescription(
  input: unknown,
  takt?: number | null,
): string {
  const trucks = Array.isArray(input)
    ? input.filter(
        (t): t is Record<string, unknown> =>
          t !== null && typeof t === "object",
      )
    : [];
  if (!trucks.length) return "–";
  const labels: Record<string, string> = {
    "3A": "Dreiachser",
    "2A": "Zweiachser",
    "4A": "Vierachser",
    SA: "Sattel",
    "3A4A": "Solo",
    HZ: "Hängerzug",
    KR: "Kran-LKW",
    TL: "Tieflader",
  };
  const parts = trucks.map((truck) => {
    let label =
      (truck.thermo ? "Thermo-" : "") + (labels[String(truck.type)] || "LKW");
    if (truck.allrad) label += " allrad";
    if (truck.stahlmulde) label += " Stahlmulde";
    if (truck.bordmatik) label += " Bordmatik";
    return truck.amount
      ? `${truck.amount} ${label}${truck.siteWork ? " (Bstd.)" : ""}`
      : label;
  });
  if (
    !trucks.some((t) => !!t.specialTakt || t.specialTakt === 0) &&
    takt &&
    takt > 0
  )
    parts.push(`Takt: ${takt} min.`);
  return parts.join(", ");
}
